// extracted by mini-css-extract-plugin
export default {"tooltip":"WO-z","arrow":"XO-z"};